import styles from './Footer.module.css';

function Footer(){
    return(
        <footer className='row mx-auto'>
            <hr style={{ width: '102%', marginBottom: '40px' }}/>
            <div className='col-lg text-start ps-lg-4'>
                <p className='fw-bold mb-1'>Focus</p>
                <p>Seu banco de horas particular - controle seu tempo de uma forma mais eficiente.</p>
                <p className='fw-bold mb-1 mt-4'>Focus é uma solução <img src='/img/footer/codedev2.webp' height={'20px'} className='mb-1'/></p>
                <nav>
                    <ul className='d-flex gap-2'>
                        <li><a href="https://www.codedev-tech.com.br/" target='_blank'><img src='/img/footer/codedev.webp' height={'45px'}/></a></li>
                        <li><a href="https://www.instagram.com/codedev.systems/" target='_blank'><img src='/img/footer/insta.webp' height={'45px'}/></a></li>
                        <li><a href="https://wa.me/5534988616368" target='_blank'><img src='/img/footer/wp.webp' height={'45px'}/></a></li>
                        <li><a href="https://github.com/codedev-systems/" target='_blank'><img src='/img/footer/git.webp' height={'45px'}/></a></li>
                    </ul>
                </nav>
            </div>
            <div className='col-lg d-flex ms-lg-5 ps-lg-5 mt-lg-2 mt-4'>
                <nav>
                    <ul className='text-start'>
                        <li className='mb-3'><a href="/" className='fw-bold text-dark'>HOME</a></li>
                        <li><a href="#sobre" className='text-dark'>Sobre</a></li>
                    </ul>
                </nav>
                <nav>
                    <ul className='text-start ms-lg-5 ms-4'>
                        <li className='mb-3'><a href="#beneficios" className='text-dark'>Benefícios</a></li>
                        <li><a href="#como-usar" className='text-dark'>Como Usar?</a></li>
                    </ul>
                </nav>
                <a className="ms-lg-5 ms-4 text-white btn btn-primary rounded-pill d-flex justify-content-center align-items-center" href="#download" style={{ height: '35px', width: '130px' }}>Download</a>
            </div>
            <p className='fw-bold mt-2 text-start ps-lg-4' style={{ fontSize: '15px' }}>Copyright © 2026 CodeDev</p>
        </footer>
    )
}

export default Footer